import { Container, styled, TableCell, tableCellClasses } from "@mui/material";



import {
  Typography,
  Grid,
  Button,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Paper,
  TableBody,
  Modal,
  Box,
  CircularProgress
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FlakyIcon from '@mui/icons-material/Flaky';
import PendingIcon from '@mui/icons-material/Pending';
import { DatePicker, Input, Select } from "antd";
import { FileProcessing } from "components/BulkActions/FileProcessing";
import { ValidateFile } from "components/BulkActions/ValidateFile";
import { useEffect, useState } from "react";
import { getDownloadReport, getIssuancesInProgress } from "services/certifications.service";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#E6E6E6",
    color: "#4D4D4D",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#4D4D4D",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

let cols = ["ID", "file_name", "Total layout", "#Emitidos", "#Errores", "Estado", "Acciones"]

export function IssuancesInProgress(): JSX.Element {
  const [data, setData] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState<any[]>([]);
  const [type, setType] = useState<string>("fc3");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [error, setError] = useState<string>("");
  
  useEffect(() => {
    let startDate = "", endDate = "";
    if (dateRange.length > 0) {
      startDate = dateRange[0].format("YYYY-MM-DD");
      endDate = dateRange[1].format("YYYY-MM-DD");
    }
    
    // FC3 = 1, Certificaciones = 2
    const partnerId = type === "certification" ? 2 : 1;
    
    setError("");
    setIsLoading(true);
    getIssuancesInProgress(startDate, endDate, partnerId, search)
      .then((resp) => {
        setData(resp.data || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching issuances:', error);
        setError('Error al cargar las emisiones. Por favor intenta de nuevo.');
        setIsLoading(false);
      });
  }, [dateRange, type, search]);

  return (
    <div style={Styles.container}>
      <h1 style={{ fontSize: "1.5rem" }}>Resumen de emisiones</h1>
      
      <div>
      
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '50%'}}><label style={{width: '30%'}}>Rango de fechas: </label><DatePicker.RangePicker format="YYYY-MM-DD" onChange={(value) => Array.isArray(value) ? setDateRange(value) : setDateRange([])} /></div>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '50%'}}><label style={{width: '30%'}}>Tipo: </label><Select defaultValue="fc3" style={{width: '70%'}} onChange={(value) => setType(value.toString())}>
          <Select.Option value="certification">Certificaciones</Select.Option>
          <Select.Option value="fc3" defaultChecked>FC3</Select.Option>
        </Select>
      </div>
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '50%'}}>
        <label>Buscar por nombre de archivo: </label><Input type="text" onChange={(value) => setSearch(value.target.value)} />
      </div>
      </div>
      
      {error && (
        <div style={{color: 'red', padding: '1rem', marginTop: '1rem', backgroundColor: '#ffebee', borderRadius: '4px'}}>
          {error}
        </div>
      )}
      
      <CircularProgress style={{visibility: isLoading ? 'visible' : 'hidden', margin: '1rem 0'}} />
      <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                {cols.map((col, index) => (
                  <StyledTableCell key={index}>{col}</StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => {
                const processedPercentage = row.found_rows > 0
                  ? ((row.successful_rows + row.failed_rows) / row.found_rows) * 100
                  : 0;
                const isReportReady = processedPercentage >= 97 && processedPercentage <= 100;
                return (
                <StyledTableRow key={'row-'+index}>
                  <StyledTableCell key={'id-'+index}>{row.fiid}</StyledTableCell>
                  <StyledTableCell key={'file-'+index}>{row.fcfileurl}</StyledTableCell>
                  <StyledTableCell key={'found-'+index}>{row.found_rows}</StyledTableCell>
                  <StyledTableCell key={'successful-'+index}>{row.successful_rows}</StyledTableCell>
                  <StyledTableCell key={'failed-'+index}>{row.failed_rows}</StyledTableCell>
                  <StyledTableCell key={'status-'+index}>

                  {row.found_rows - row.successful_rows == 0 ? <CheckCircleIcon color="success"></CheckCircleIcon> : (row.found_rows - row.successful_rows - row.failed_rows == 0 ? <FlakyIcon color="error"></FlakyIcon> : <PendingIcon color="info"></PendingIcon>)}
                    {row.found_rows - row.successful_rows == 0 ? "Completado" : (row.found_rows - row.successful_rows - row.failed_rows == 0 ? "Completado con errores" : "En proceso")}
                  </StyledTableCell>
                  <StyledTableCell key={'actions-'+index}>
                    {isReportReady ?
                    <a onClick={
                      () => {
                        getDownloadReport(row.fiid).then((res) => {
                          let url = res.data.resource.download_url
                          window.open(url, '_blank');
                        })
                      }
                    }>Descargar reporte</a>
                    : <a style={{color: 'gray'}}>Descargar reporte</a>}
                  </StyledTableCell>
                </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

const Styles = {
  container: {
    backgroundColor: "#fff",
    padding: "1.5rem",
    marginTop: "1.5rem",
    borderRadius: "0.5rem",
    boxShadow: "0px 1px 2px 0px rgba(25, 57, 91, 0.30), 0px 1px 3px 1px rgba(25, 57, 91, 0.15)",
  }
};
